import { Descriptions } from 'antd';
import SkeletonInput from 'antd/lib/skeleton/Input';

const PurchaseOrderInfoViewSkeleton = ({ active }: { active: boolean }) => {
  return (
    <>
      <Descriptions title="Purchase Order">
        <Descriptions.Item label="Code">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Order Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Required Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Source Document">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Vendor">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Destination">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Currency">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Terms">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Prepared By">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Prepared Date" span={2}>
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Approved By">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Approved Date" span={2}>
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Remarks" span={3}>
          <SkeletonInput active={active} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default PurchaseOrderInfoViewSkeleton;
